(function (app) {
    app.provider("emailApi", [function () {
        this.$get = ["complianceHubApiGateway", function (complianceHubApiGateway) {
            var service = {};

            service.createAndSend = function(email) {
                return complianceHubApiGateway.post("/Emails", email);
            };

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line